import ModalResponsive from '@app/components/ModalResponsive';
import { useIsTabletOrMobileScreenSize } from '@app/utils/media-query';
import React from 'react';
import { useRestaurantContext } from '../context';
import { Content } from './styles';

type Props = {
  isVisible: boolean;
  onClose: () => void;
  videoId: string;
};

export default function YoutubeVideoModal({ isVisible, onClose, videoId }: Props) {
  const { primaryColor, secondaryColor } = useRestaurantContext();
  const isTableOrMobile = useIsTabletOrMobileScreenSize();

  return (
    <ModalResponsive
      open={isVisible}
      onClose={onClose}
      hiddenMobileBar
      appBarConfig={{
        title: '',
        color: primaryColor,
        tintColor: secondaryColor,
      }}
      desktopWidthContent={500}
      desktopMaxHeightContent="90%"
      desktopHeightContent="100%"
    >
      <>
        {isVisible && (
          <Content>
            <iframe
              width="100%"
              height={'100%'}
              src={`https://www.youtube.com/embed/${videoId}`}
              title="Onde é preparada a sua comida!"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen={false}
            />
          </Content>
        )}
      </>
    </ModalResponsive>
  );
}
